export default "__VITE_ASSET__Dj_E_c3A__"